export default __webpack_public_path__ + "static/media/careers-bg.23831a91.png";